import React from 'react';

import { MainView, NoAccessView } from '@repo/ui/Views';
import BrandView from '@/features/tcr/components/BrandView';

import { useQuery } from '@apollo/client/react';
import BRAND_SHOW_Q from '../gql/brandShow.gql';

import { useUser } from '@repo/hooks/useUser';
import { useParams } from 'react-router';
import { POLICIES } from '@/lib/Authorization';

const Brand = () => {
  const params = useParams();
  const brandId = params.brandId;

  const user = useUser();

  const { loading, data, error } = useQuery(BRAND_SHOW_Q, {
    variables: {
      id: String(brandId),
    },
  });

  return POLICIES['csp_brands:show'](user) ? (
    <MainView
      title={loading ? `Loading...` : `Brand Name: ${data?.cspBrand.displayName}`}
      loading={loading}
    >
      <BrandView data={data} loading={loading} error={error} />
    </MainView>
  ) : (
    <NoAccessView />
  );
};

export default Brand;
